import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { PureComponent } from 'react';
import Image from '../../../../../../shared/Image/Image';
import { Button } from '../button';
import { Ingredient } from '../ingredient';
import './empty-screen.less';
export class EmptyScreen extends PureComponent {
    render() {
        const rootClass = classnames({
            'empty-screen': true,
        }, this.props.className);
        return (_jsxs("div", Object.assign({ className: rootClass }, { children: [this.props.image && (_jsx(Image, { className: "empty-screen__image", src: this.props.image, alt: this.props.imageAlt ? this.props.imageAlt : '' })), _jsx("h2", Object.assign({ className: "empty-screen__headline" }, { children: this.props.headline })), !!this.props.children && (_jsx("div", Object.assign({ className: "empty-screen__text" }, { children: this.props.children }))), !!this.props.ingredients &&
                    Object.keys(this.props.ingredients).map((k, index) => {
                        var _a, _b;
                        return (_jsx(Ingredient, { className: "empty-screen__ingredient", title: k, url: (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.ingredients) === null || _b === void 0 ? void 0 : _b[k] }, index));
                    }), this.props.buttonText && (_jsx(Button, Object.assign({ className: "empty-screen__button", onClick: this.props.buttonClick, to: this.props.buttonLink }, { children: this.props.buttonText })))] })));
    }
}
